import React, { useState , useContext, useEffect} from 'react';
import { UserContext } from '../UserContext';
import { Button, Card, Row , Col , Image, Alert} from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import Spinner from 'react-bootstrap/Spinner';
import favicon from '../assets/favicon.ico';
const BenefitCodeCard = ({ Benefit }) => {
    const {findBenefitByCode, benefit , updateBenefit, setBenefit} = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const [code,setCode] = useState("");
    const [benefitFound,setBenefitFound] = useState(true);
    useEffect( () => {
        setLoading(false);
    },[benefit]);
    const benefitValidate = () => {
        setLoading(true);
        updateBenefit();
    }

    const getBenefit = () => {
        setLoading(true);
        findBenefitByCode(code);
        if(Object.keys(benefit).length  === 0){
           setBenefitFound(false);
        }else{
            setBenefitFound(true);
        }
    }

    const resetSearch  = () => {
        setBenefit({});
        setBenefitFound(true);
    }


    const spinerRush  =  <Spinner className="align-middle" animation="grow"   variant="dark" role="status">
                        <Image rounded width={20} height={20} src={favicon} />
                    </Spinner>;
    return(
        <Card className="text-center  "   >

            <Card.Body>
                { benefit &&  <h4>{benefit?.convenio?.nombre}</h4> }
                <Row>
                    <Col lg={2} md={2} xs={1}></Col>
                    {
                        !loading && Object.keys(benefit).length  === 0 && <Col lg={8} md={8} xs={10}>
                            <div className="mb-2">
                                <label  className="form-label">Código promocional</label>
                                <Row>
                                    <Col md={3} xs={2}/>
                                    <Col md={6} xs={8}>
                                        <input className='form-control input-lg'  maxLength={6}  onChange={ (e) => setCode(e.target.value)  }/>
                                        <br />
                                        {!benefitFound && <Alert variant="info" >
                                            <Icon.ExclamationCircle /> &nbsp;
                                            Beneficio no encontrado
                                        </Alert>}
                                    </Col>
                                    <Col md={3} xs={2}/>
                                </Row>
                            </div>

                            <Button variant="danger" className='mt-2' onClick={getBenefit}>
                                Buscar Beneficio <Icon.Search></Icon.Search>
                            </Button>
                        </Col>

                    }


                    {loading && spinerRush }
                    { Object.keys(benefit).length  !== 0  && <Col lg={8} md={8} xs={10}>
                        <Card.Text className='mt-1'>
                            {benefit?.convenio?.beneficio}

                        </Card.Text>
                        <h6>Cliente : {benefit?.usuario?.nombre}</h6>
                        {!benefit.estado && <Button className='mt-3' variant="outline-primary" size='lg' onClick={benefitValidate}>
                                Validar beneficio <br></br><Icon.CheckSquare size={30}/>
                        </Button>}

                        {
                            benefit.estado &&
                            <Alert variant="danger" >
                                <Icon.Check2All /> &nbsp;
                                Beneficio cobrado
                            </Alert>
                        }


                        <div className="d-grid pt-2">
                            ~ o ~
                        </div>
                        <div className="d-grid">
                            <Button  variant='link' onClick={resetSearch}>
                                Buscar otro código promocional
                            </Button>
                        </div>
                    </Col> }
                    <Col lg={2} md={2} xs={1}></Col>
                </Row>
            </Card.Body>
        </Card>

    )
}
export default BenefitCodeCard;